export enum BrsTokenServiceKey {
	brsToken = 'brsToken',
	brsTokenExpiry = 'brsTokenExpiry'
}

export interface IBrsToken {
	result: string;
	token: string;
	tokenExp: string;
}

// Cognito groups used for app user permissions, needs to match defined cognito groups
// TODO update once we know the cognito group
export enum PermissionCognitoGroups {
	registrations = 'z5-cloud-portal'
}
